<app-sidenav
    [mode]="data.mode"
></app-sidenav>
